<template>
    <div :class="[
                'lp-hero',
                'lp-hero--bg-image',
                slide.CssClass,
                {'fg-image': slide.ImageUrl && slide.ImageUrl != ''}
             ]"
         :style="{
                'background-image': slide.BackgroundImageUrl != '' && `url(${slide.BackgroundImageUrl})`,
                'background-position': `${slide.BackgroundImageX}% ${slide.BackgroundImageY}%`
             }">
        <div class="lp-hero__overlay" :style="{'opacity': `${slide.OverlayOpacity / 100}`}"></div>
        <div :class="['lp-hero__content', slide.ContentClass]" v-html="slide.Content">
        </div>
        <div v-if="slide.ImageUrl != '' && slide.ImageUrl" :class="['lp-hero__fg-image', slide.FgImageClass]">
            <img :src="slide.ImageUrl" :alt="slide.ImageAlt" :title="slide.ImageTitle" />
        </div>
    </div>
</template>
<script lang="ts">
    import { PropType, reactive } from "vue";
    import { ISlide } from "../helpers/HeroCarouselTypes";

    export default {
        name: 'HeroCarouselSlide',
        props: {
            slide: {
                type: Object as PropType<ISlide>,
                required: true,
            },
        },
    };
</script>
